import { Item as DropdownMenuItem } from '@radix-ui/react-dropdown-menu';
import { ReactNode } from 'react';

import { cn } from '@/services/utils';

interface FilterMenuItemProps {
    children: ReactNode;
    title?: string;
    isActive?: boolean;
    onSelect?: () => void;
    preventClose?: boolean;
    className?: string;
}

export function FilterMenuItem({
    children,
    title,
    isActive = false,
    onSelect,
    preventClose = false,
    className,
}: FilterMenuItemProps) {
    return (
        <DropdownMenuItem
            title={title}
            className={cn(
                'tw-flex tw-w-full tw-items-center tw-px-5 tw-py-1.5 tw-text-t-sm tw-text-t-primary tw-cursor-pointer tw-outline-none tw-whitespace-nowrap',
                'data-[highlighted]:tw-bg-fill-primary-hover hover:tw-bg-fill-primary-hover',
                isActive && 'tw-bg-info-lighter',
                className,
            )}
            onSelect={(event) => {
                if (preventClose) {
                    event.preventDefault();
                }
                onSelect?.();
            }}
        >
            {children}
        </DropdownMenuItem>
    );
}
